<template>
  <div class="chat-profile-sidebar" :class="{ show: isShowMe }">
    <!-- Header -->
    <div
      class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
    >
      <h5 class="mb-0">Thông tin quyền</h5>
      <feather-icon
        class="ml-1 cursor-pointer"
        icon="XIcon"
        size="16"
        @click="$emit('hide-edit')"
      />
    </div>
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="profile-sidebar-area scroll-area"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Tên quyền"
            rules="required"
          >
            <b-form-group label="Tên quyền" label-for="name">
              <b-form-input
                id="name"
                v-model="data.name"
                :state="getValidationState(validationContext)"
                trim
                :disabled="isWait"
                placeholder="Nhập tên"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Code"
            rules="required"
          >
            <b-form-group label="Code" label-for="code">
              <b-form-input
                id="code"
                v-model="data.code"
                :state="getValidationState(validationContext)"
                trim
                :disabled="isWait"
                placeholder="Code"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-group label="Đơn vị sử dụng" label-for="donViSuDung">
            <treeselect
              v-on:select="formatDonViUsings"
              v-on:deselect="formatRemoveDonViUsing"
              :options="listDonVi"
              value-format="object"
              :value="data.unitUsing"
              :flat="true"
              :searchable="true"
              :show-count="true"
              :default-expand-level="1"
              :normalizer="normalizer"
              placeholder="Chọn đơn vị"
              :multiple="true"
            />
          </b-form-group>

          <b-form-group label="Chỉ xem" label-for="isOnlySee">
            <b-form-checkbox v-model="data.isOnlySeeMe" />
          </b-form-group>

          <b-form-group label="Đơn vị đặc biệt" label-for="isSpecialUnit">
            <b-form-checkbox v-model="data.isSpecialUnit" />
          </b-form-group>

          <b-form-group
            label="Đơn vị"
            label-for="donVi"
            v-if="data.isSpecialUnit == true"
          >
            <treeselect
              v-on:select="formatDonVis"
              v-on:deselect="formatRemoveDonVi"
              :options="listDonVi"
              value-format="object"
              :value="data.donVis"
              :flat="true"
              :searchable="true"
              :show-count="true"
              :default-expand-level="1"
              :normalizer="normalizer"
              placeholder="Chọn đơn vị"
              :multiple="true"
            />
          </b-form-group>
          <validation-provider
            #default="validationContext"
            name="Cấp"
            rules="required"
          >
            <b-form-group label="Cấp" label-for="cap">
              <b-form-input
                id="cap"
                v-model="data.level"
                :state="getValidationState(validationContext)"
                trim
                :disabled="isWait"
                placeholder="Cấp"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              :disabled="isWait"
              type="submit"
            >
              Lưu
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :disabled="isWait"
              @click="$emit('hide-edit')"
            >
              Hủy
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { GetTree } from "@/services/api/DefaultTemplate/DonViService";
import {
  GetById,
  RolesCreate,
  RolesUpdate,
} from "@/services/api/DefaultTemplate/RoleService";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormCheckbox,
    Treeselect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  watch: {
    isShowMe(val) {
      if (this.data && !this.data.id) {
        this.data.isOnlySeeMe = false;
        this.data.isSpecialUnit = false;
      }
    },
  },
  props: {
    isShowMe: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: true,
    },
  },
  data() {
    return {
      isWait: false,
      required,
      listDonVi: [],
    };
  },
  created() {
    this.getDonVi();
  },
  // watch: {
  //   isShowMe(val) {
  //     console.log(val);
  //     if (val) {
  //       this.listUsing = this.data.unitUsing;
  //       this.list = this.data.donVis;
  //     }
  //   },
  // },
  methods: {
    formatDonViUsings(node, instanceId) {
      let index = this.data.unitUsing?.findIndex((x) => x.id == node.id);
      if (index == -1 || index == undefined) {
        if (!this.data.unitUsing) {
          this.data.unitUsing = [];
        }
      }
      this.data.unitUsing.push({
        id: node.id,
        ten: node.label,
        maCoQuan: node.maCoQuan,
        isSyncQG: node.isSyncQG,
      });
    },
    formatRemoveDonViUsing(node, instanceId) {
      let value = this.data.unitUsing?.find((x) => x.id == node.id);
      if (value != null) {
        this.data.unitUsing = this.data.unitUsing.filter(
          (x) => x.id != value.id
        );
      }
    },
    formatDonVis(node, instanceId) {
      let index = this.data.donVis?.findIndex((x) => x.id == node.id);
      if (index == -1 || index == undefined) {
        if (!this.data.donVis) {
          this.data.donVis = [];
        }
      }
      this.data.donVis.push({
        id: node.id,
        ten: node.label,
        maCoQuan: node.maCoQuan,
        isSyncQG: node.isSyncQG,
      });
    },
    formatRemoveDonVi(node, instanceId) {
      let value = this.data.donVis?.find((x) => x.id == node.id);
      if (value != null) {
        this.data.donVis = this.data.donVis.filter((x) => x.id != value.id);
      }
    },

    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    getDonVi() {
      GetTree().then((response) => {
        this.listDonVi = response.data;
      });
    },
    async onSubmit() {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        if (this.data.id && this.data.id != "") {
          //Update
          this.isWait = true;
          var res = await RolesUpdate(this.data);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            this.$emit("hide-edit");
            this.$emit("reload-list");
            this.$emit("update-current", this.data);
          }
        } else {
          //Add
          this.isWait = true;
          var res = await RolesCreate(this.data);
          this.isWait = false;
          if (res.isError) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thất bại",
                icon: "AlertTriangleIcon",
                variant: "error",
                text: res.message,
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Thành công",
                icon: "CheckIcon",
                variant: "success",
                text: res.message,
              },
            });
            this.$emit("hide-edit");
            this.$emit("reload-list");
          }
        }
      }
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };
    return {
      refFormObserver,
      getValidationState,
      resetForm,
      perfectScrollbarSettings,
    };
  },
};
</script>

<style lang="scss" scoped>
#user-status-options ::v-deep {
  .custom-radio {
    margin-bottom: 1rem;
  }
}

.scroll-area {
  height: 350px;
}

.chat-application .chat-profile-sidebar .profile-sidebar-area {
  height: calc(100% - 40px);
}
</style>
